// Shared password policy for Register + ResetPassword. Keep both pages'
// displayed requirements and enforced Form.Item rules in sync from here.

export const PASSWORD_REQUIREMENTS = [
  "Be at least 8 characters long",
  "Have one uppercase character",
  "Have one lowercase character",
  "Have one number",
  "Have one special character",
];

export const PASSWORD_RULES = [
  { required: true, message: "Please input your password!" },
  { min: 8, message: "Password must be at least 8 characters." },
  { pattern: /[a-z]/, message: "Password must include a lowercase letter." },
  { pattern: /[A-Z]/, message: "Password must include an uppercase letter." },
  { pattern: /\d/, message: "Password must include a number." },
  {
    pattern: /[^A-Za-z0-9]/,
    message: "Password must include a special character.",
  },
];
